import * as React from 'react'

import lazyload from './lazy-load'
import type { Loader } from './lazy.types'

/**
 * Lazyload utility for modal component.
 * It uses default `ModalPlaceHolder` as a fallback.
 *
 * @note the modal component shoulad have `show` props availble, according to our default modal props,
 * or, the parent that consume this modal should provide `show` props.
 *
 * @todo add modal placeholder as a fallback
 *
 */
export default function lazyModal<P extends { show: boolean }>(loader: Loader<P>) {
  // invoke lazy import from loader
  const ModalComponent = lazyload(loader, {
    loading: () => null, // TODO: add modal place holder here
  })

  const LazyModal = (props: P) => {
    /**
     * Determine modal already open or not
     */
    const [alreadyOpen, setAlreadyOpen] = React.useState(false)

    const visible = props.show

    React.useEffect(() => {
      if (visible) {
        setAlreadyOpen(true)
      }
    }, [visible])

    // just return null if modal not already open at the first time
    if (!alreadyOpen) return null

    // Download and Render component Modal if alreadyOpen.
    // If component already downloaded, the React.lazy not download again.
    return <ModalComponent {...props} />
  }

  return LazyModal as React.ComponentType<P>
}
